<ng-container *ngIf="notEmpty$ | async; else stubTmp">
  <ng-container *ngIf="isTeacher && classroom?.visit_info?.is_author">
    <div class="invite">
      <div class="invite-message" (click)="openInviteModal()">
        <span class="link">{{'classrooms.menu.invite' | translate}}</span>
      </div>
    </div>
  </ng-container>
  <div class="list">
    <ng-container *ngFor="let participant of participants; trackBy: trackParticipantsByFn">
      <div class="user-card-wrap" [class.removed]="deletedUsers?.includes(participant.user_id)">
        <app-user-card-mini *ngIf="participant.user" [user]="participant.user"></app-user-card-mini>
      </div>
    </ng-container>
  </div>
</ng-container>

<app-pagination
  [enabled]="loaded$ | async"
  [loading]="loading$ | async"
  [pagination]="pagination$ | async"
  [nothingMoreText]="''"
  baseUrl=""
  (nextPage)="nextPage()"></app-pagination>

<ng-template #stubTmp>
  <app-no-content-stub
    *ngIf="loaded$ | async"
    (onClick)="onInvite()"
    [icon]="'people'"
    [text]="'classrooms.classroom-page.participants.stub.description'"
    [link]="'classrooms.menu.invite'">
  </app-no-content-stub>
</ng-template>

<ng-template [ngIf]="inviteModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileInviteForm"
             [canClose]="false"
             [middle]="true"
             (closed)="closeInviteModal($event)">
    <app-modal-body>
      <app-invite-to-classroom [classroom]="classroom"
                               (invited)="onParticipantsInvited($event)">
      </app-invite-to-classroom>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileInviteForm>
    <app-mobile-modal (closed)="closeInviteModal($event)">
      <app-mobile-modal-title>{{ 'classrooms.invite.title' | translate }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-invite-to-classroom [classroom]="classroom"
                                 (invited)="onParticipantsInvited($event)">
        </app-invite-to-classroom>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>
